module.exports = __webpack_public_path__ + "static/media/Y1.PNG.dc5a41d7.png";